import React, { useCallback } from 'react';
import { FileDownloader } from 'components/FileLoader/FileDownloader';
import './DetailsFileLoader.less';

const detailsLoaderClass = 'dp-entitydetails-loader';

export interface DetailsFileUploaderInterface {
  getUploadHolder?: (element: HTMLElement) => void;
  downloadDocument?: () => void;
}

export function DetailsFileLoader({ getUploadHolder, downloadDocument }: DetailsFileUploaderInterface) {
  const detailsUpload = useCallback(
    (node: HTMLDivElement) => {
      getUploadHolder && getUploadHolder(node);
    },
    [getUploadHolder]
  );

  return (
    <div className={detailsLoaderClass}>
      {getUploadHolder && <div ref={detailsUpload} className={`${detailsLoaderClass}__upload`} />}
      {downloadDocument && getUploadHolder && <div className={`${detailsLoaderClass}__separator`} />}
      {downloadDocument && (
        <div className={`${detailsLoaderClass}__download`}>
          <FileDownloader onClick={downloadDocument} />
        </div>
      )}
    </div>
  );
}
